<script>
// TODO: Use DpListItem instead
  export default {
    inheritAttrs: true,
    name: "DpMobileListItem"
  }
</script>

<template>

  <div class="dp-mobile-list-item">
    <div class="dp-mobile-list-item__headline">
      <slot name="headline"></slot>
    </div>
    <div class="dp-mobile-list-item__description">
      <slot name="description"></slot>
    </div>
  </div>

</template>

<style lang="scss">

  .dp-mobile-list-item {
    padding: 1em 1.3em;
    margin: .9em 0;
    border: 2px #ebeef5 solid;
    border-radius: 10px;

    .dp-mobile-list-item__headline {
      font-size: 1.5em;
      letter-spacing: -0.5px;
      color: #515151;
      margin-bottom: 0.2em;
    }

    .dp-mobile-list-item__description {
      color: #515151;
      font-size: 1em;
    }
  }


</style>
